module.exports = __webpack_public_path__ + "fonts/windowsActive_60x60.70fcad8a8d7aa7b91aa6461f2ddfb22c.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/windowsActive_60x60.png
// module id = 779
// module chunks = 9